
import _ from "lodash";

export const capitalizeFirstLetter = (string: string) => {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return "";
    }
};
 
export const currencyFormat=(price: any)=> {
  price=String(price);
  if(price == null)
  {
    price = '00';
  }
  if (price) {
    return '$ ' + price.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  } else {
    return "";
  }
}

export const calculateGroupedTotals = (data: any[]) => {
  if (!Array.isArray(data)) return data;

  const leafCodes = ["VP", "VP/IP", "IP"];
  const groupCodes = ["SST", "ST", "GT"];

  // 1. Separate leaves (VP, VP/IP, IP)
  const leaves = data.filter(item =>
    leafCodes.includes(item.account_chart?.report_code)
  );

  // 2. Prepare a grouped index for fast lookup
  const leafIndex = _.groupBy(leaves, (leaf: any) => leaf.account_chart.account);

  // 3. Map over full input array and only update SST/ST/GT nodes
  const updatedData = data.map(item => {
    const code = item.account_chart?.report_code;

    // Only update SST, ST, GT
    if (!groupCodes.includes(code)) {
      return item; // return unchanged
    }

    const start_range = item.account_chart.parent?.start_range || 0;
    const end_range = item.account_chart.account || 0;

    if (start_range > end_range) {
      return { ...item, total_amount: 0, prev_year_total_amount: 0 }; // invalid range
    }

    // 4. Collect all leaf nodes in the given range
    const matchedLeaves = _.flatten(
      _.range(start_range, end_range + 1).map((acc: any) => leafIndex[acc] || [])
    );

    // 5. Sum all totals within the range
    const total = _.sumBy(matchedLeaves, "total_amount");
    const prevYearTotal = _.sumBy(matchedLeaves, "prev_year_total_amount");

    // 6. Return updated object with new total_amount
    return {
      ...item,
      total_amount: total,
      prev_year_total_amount: prevYearTotal
    };
  });

  return updatedData;
};
